import { convertNullStringToNullInteger } from "./normalize.js";
/**
 * Canonical business_type table — the single source of truth for the key↔WP-id
 * mapping across services. 14 entries (incl. Independent 6372112).
 *
 * Deliberately carries NO display label: the old wp-syncer `BUSINESS_TYPES[].label`
 * was dead code and drifted from the exact MySQL strings. The exact strings live
 * in WP_ID_TO_EXACT_LABEL below (load-bearing — promote + the legal500-bff
 * directory filter depend on them verbatim).
 *
 * staff-ui seam: a future UI-short display-label map keyed by BusinessTypeKey
 * (e.g. `keyToDisplayLabel`) belongs here as a NEW export — additive, do not fold
 * it into this table or into WP_ID_TO_EXACT_LABEL (the two vocabularies differ).
 */
export const BUSINESS_TYPES = [
    { key: "law_firm", wpId: 1 },
    { key: "law_firm_network", wpId: 2 },
    { key: "media_agency", wpId: 3 },
    { key: "non_law_firm", wpId: 4 },
    { key: "patma", wpId: 5 },
    { key: "scottish_stables", wpId: 6 },
    { key: "bar_england_wales", wpId: 7 },
    { key: "lpc_provider", wpId: 154604 },
    { key: "uk_support_service_providers", wpId: 154605 },
    { key: "corporate_council", wpId: 154606 },
    { key: "government", wpId: 154607 },
    { key: "uk_inhouse_directory", wpId: 154608 },
    { key: "mediators_arbitrators", wpId: 2961200 },
    { key: "independent", wpId: 6372112 },
];
/**
 * Exact MySQL `api_business_type` label strings, keyed by WP id. Carried VERBATIM
 * — id 7 is the hyphen form "The Bar - England & Wales" (legal500-bff
 * directory-page.ts exact-string-matches it; the en-dash variant 404s the Bar
 * directory). Promote writes these to SQLite.
 */
const WP_ID_TO_EXACT_LABEL = new Map([
    [1, "Law firms and partnership"],
    [2, "Law firms network"],
    [3, "Media agencies"],
    [4, "Non law firms"],
    [5, "Patent and Trademark Attorneys – PATMA"],
    [6, "Scottish stables"],
    [7, "The Bar - England & Wales"],
    [154604, "Legal Practice Course Providers - LPC"],
    [154605, "UK support service providers"],
    [154606, "Corporate Council"],
    [154607, "Government"],
    [154608, "UK in-house lawyer directory"],
    [2961200, "Mediators and Arbitrators"],
    [6372112, "Independent"],
]);
const wpIdToKey = new Map(BUSINESS_TYPES.map(({ wpId, key }) => [wpId, key]));
const keyToWpId = new Map(BUSINESS_TYPES.map(({ key, wpId }) => [key, wpId]));
/**
 * Returns the WP business_type_id for a given key, or null if unrecognised.
 */
export function mapBusinessTypeKeyToWpId(key) {
    if (!key)
        return null;
    return keyToWpId.get(key) ?? null;
}
/**
 * Normalises a raw WP business_type_id (number, numeric string, null, undefined,
 * "", or "NULL") and returns the matching key, or null if unmapped.
 */
export function mapBusinessTypeIdToKey(value) {
    const id = convertNullStringToNullInteger(value);
    if (id === null)
        return null;
    return wpIdToKey.get(id) ?? null;
}
/**
 * Normalises a raw WP business_type_id and returns the exact MySQL label string
 * (the value the directory page filters on), or null if unmapped/null.
 */
export function mapWpIdToBusinessTypeLabel(value) {
    const id = convertNullStringToNullInteger(value);
    if (id === null)
        return null;
    return WP_ID_TO_EXACT_LABEL.get(id) ?? null;
}
//# sourceMappingURL=business-types.js.map